import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import { memo, useEffect, useMemo, useRef } from 'react';

import { useUser } from '../hooks/useUser';
import { useTranslateFn } from '../Translate';

import { trackedVideoKinds } from '@services/JwPlayerService';
import GoogleTagManagerHelper from '@tracking/gtm-helper';
import IdpHandler from '@user/IdpHandler';

import * as classes from './styles.module.scss';

export type VideoLockProps = {
  videoid?: string;
  videoTitle?: string;
  videoKind?: string;
  type?: string;
  trackingProps?: {
    impressionAction?: string;
    impressionName?: string;
    clickAction?: string;
    clickName?: string;
  };
};
export const defaultTrackingProps = {
  impressionAction: 'Login to watch highlights',
  impressionName: 'login_to_watch_highlights_impression',
  clickAction: 'Login to watch highlights',
  clickName: 'login_to_watch_highlights_click',
};
const VideoLock = ({
  videoid,
  videoTitle,
  videoKind,
  type = 'login',
  trackingProps = defaultTrackingProps,
}: VideoLockProps) => {
  const user = useUser();
  const t = useTranslateFn();
  const ref = useRef(undefined);
  const tracked = useRef(false);
  const isVisible = useViewportSpy(ref);

  const video_type = useMemo(() => {
    const kind = videoKind?.toLowerCase();
    return trackedVideoKinds.includes(kind as (typeof trackedVideoKinds)[number]) ? kind : 'video';
  }, [videoKind]);

  useEffect(() => {
    if (isVisible && videoid && !tracked.current && trackingProps?.impressionAction) {
      GoogleTagManagerHelper.event(
        'Impression',
        trackingProps.impressionAction,
        `${videoid}: ${videoTitle}`,
        {
          video_type,
          video_reference: `${videoid}: ${videoTitle}`,
        },
        trackingProps.impressionName,
      );
      tracked.current = true;
    }
  }, [isVisible, trackingProps.impressionAction, trackingProps?.impressionName, videoTitle, video_type, videoid]);

  const onLockClick = () => {
    videoid &&
      trackingProps.clickAction &&
      GoogleTagManagerHelper.event(
        'Click',
        trackingProps.clickAction,
        `${videoid}: ${videoTitle}`,
        { video_type, video_reference: `${videoid}: ${videoTitle}` },
        trackingProps.clickName,
      );
    type === 'login' ? IdpHandler.showLogin() : IdpHandler.showRegister();
  };

  if (user.logged) return null;

  return (
    <div ref={ref} className={classes.container}>
      <PkButton role='button' onPkClick={onLockClick}>
        <PkIcon className='pk-mr--xs' name='actions-profile' />
        {t('login_highlights')}
      </PkButton>
    </div>
  );
};

export default memo(VideoLock);
